module.exports = ".pf-field > input {\n\tpadding-right: 12px;\n}\n\n.origin {\n\tborder-color: blue\n}\n\n.destination {\n\tborder-color: green\n}"